// Clinic settings / branding (pages/Settings.jsx).
const strings = {
  es: {
    settings_sub: "Personaliza cómo se ve la plataforma para tu equipo.",
    branding: "Marca de la plataforma",
    branding_desc: "El nombre y logotipo se muestran en el menú, la pestaña del navegador y el encabezado.",
    platform_name: "Nombre de la plataforma",
    platform_name_hint: "Déjalo vacío para usar «ClinicOS».",
    upload_logo: "Subir logotipo",
    change_logo: "Cambiar logotipo",
    logo_hint: "PNG, JPG, WebP o SVG. Se ajusta a 256 px; de preferencia cuadrado y con fondo transparente.",
    logo_bad_type: "Formato no válido. Usa PNG, JPG, WebP o SVG.",
    logo_too_big: "El archivo es demasiado grande (máx. 500 KB).",
    logo_read_error: "No se pudo leer la imagen.",
    branding_saved: "Marca actualizada",
    restore_default: "Restablecer a ClinicOS",
    branding_scope: "Lo verán todos los usuarios de tu clínica: personal de la clínica, médicos y asistentes. El logotipo también aparece en las recetas en PDF.",
  },
  en: {
    settings_sub: "Customize how the platform looks for your team.",
    branding: "Platform branding",
    branding_desc: "The name and logo appear in the menu, the browser tab and the header.",
    platform_name: "Platform name",
    platform_name_hint: "Leave empty to use “ClinicOS”.",
    upload_logo: "Upload logo",
    change_logo: "Change logo",
    logo_hint: "PNG, JPG, WebP or SVG. Scaled to 256 px; square with a transparent background works best.",
    logo_bad_type: "Unsupported format. Use PNG, JPG, WebP or SVG.",
    logo_too_big: "The file is too large (max 500 KB).",
    logo_read_error: "Couldn't read the image.",
    branding_saved: "Branding updated",
    restore_default: "Restore ClinicOS default",
    branding_scope: "Everyone in your clinic sees it: clinic staff, doctors and assistants. The logo also appears on PDF prescriptions.",
  },
};

export default strings;
